import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import NaturePeopleOutlinedIcon from '@mui/icons-material/NaturePeopleOutlined';
import ConstructionOutlinedIcon from '@mui/icons-material/ConstructionOutlined';
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';
import { COLORS, FONTS } from '../../theme/tokens';

const TRUST_ITEMS = [
  { Icon: PublicOutlinedIcon, key: 'Heritage' },
  { Icon: ConstructionOutlinedIcon, key: 'Handcrafted' },
  { Icon: NaturePeopleOutlinedIcon, key: 'Nature' },
];

const TrustItem = ({ Icon, title, text }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: { xs: 'row', sm: 'column' },
      alignItems: { xs: 'flex-start', sm: 'center' },
      textAlign: { xs: 'left', sm: 'center' },
      gap: { xs: 1.5, sm: 1 },
      p: { xs: 1, sm: 2 },
    }}
  >
    <Icon sx={{ fontSize: { xs: 32, sm: 44 }, color: COLORS.gold, flexShrink: 0 }} />
    <Box>
      <Typography
        component="h2"
        sx={{
          fontFamily: FONTS.heading,
          fontWeight: 600,
          fontSize: '1rem',
          color: COLORS.textPrimary,
          mb: 0.5,
        }}
      >
        {title}
      </Typography>
      <Typography sx={{ fontSize: '0.875rem', color: COLORS.textBody, lineHeight: 1.5 }}>
        {text}
      </Typography>
    </Box>
  </Box>
);

const BrandIntroduction = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        borderBottom: `1px solid ${COLORS.borderHairline}`,
        py: { xs: 3, md: 5 },
        px: { xs: 1, md: 3 },
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, 1fr)' },
        gap: { xs: 1, md: 4 },
        maxWidth: 960,
        mx: 'auto',
      }}
    >
      {TRUST_ITEMS.map(({ Icon, key }) => (
        <TrustItem
          key={key}
          Icon={Icon}
          title={t(`home.trust${key}Title`)}
          text={t(`home.trust${key}Text`)}
        />
      ))}
    </Box>
  );
};

export default BrandIntroduction;
